/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation, useQueryClient } from '@common-fe/common-fe';
import { AxiosResponse } from 'axios';
import _ from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { QUERY_KEY } from './useFilesList.query';

export const useFileRemoveQuery = (fileId: string) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isSuccess, isLoading } = useMutation(
    () => api.delete(API_URL.FILE_FILES_BY_FILE_ID(fileId), undefined),
    {
      onSuccess: () => {
        queryClient.setQueriesData({ queryKey: [QUERY_KEY] }, (oldData: AxiosResponse<any, any, {}>) => {
          try {
            const data = _.get(oldData, 'data', {});
            const content = _.get(data, 'content', []) as object[];
            const filtered = content.filter((item) => `${_.get(item, 'id')}` !== fileId);
            return {
              ...oldData,
              data: {
                ...data,
                content: filtered,
              },
            };
          } catch {
            return oldData;
          }
        });

        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY],
        });
      },
    }
  );

  return {
    handleRemove: mutateAsync,
    isSuccess,
    isLoading,
  };
};

export default useFileRemoveQuery;
